import { render, staticRenderFns } from "./MyJobTrayDraft.vue?vue&type=template&id=76bc204f&scoped=true"
import script from "./MyJobTrayDraft.vue?vue&type=script&lang=js"
export * from "./MyJobTrayDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc204f",
  null
  
)

export default component.exports